import classNames from 'classnames';
import { Heading, List } from 'yoso';
import { PostCard } from '~/components/Card/PostCard/PostCard';
import { T } from '~/components/I18n';
import hatCitizen from '~/components/Icon/Citizen/hatCitizen.png';
import kaia from '~/components/Icon/kaia.png';
import styles from './AdventureGuide.module.scss';

export type AdventureGuideProps = {
  className?: string;
};
export const AdventureGuide = ({ className }: AdventureGuideProps) => (
  <div className={classNames(styles.root, className)}>
    <div>
      <Heading className={styles.heading} level={3}>
        <T name="citizen_adventure_guide_title" />
      </Heading>
    </div>
    <List className={styles.body}>
      <li>
        <PostCard
          image={<img src={kaia} alt="kaia" width={90} height={90} />}
          title={<T name="citizen_adventure_guide_kaia_title" />}
          description={<T name="citizen_adventure_guide_kaia_desc" />}
        />
      </li>
      <li>
        <PostCard
          image={<img src={hatCitizen} alt="hat citizen" width={90} height={90} />}
          title={<T name="citizen_adventure_guide_citizenlv1_title" />}
          description={<T name="citizen_adventure_guide_citizenlv1_desc" />}
        />
      </li>
    </List>
  </div>
);
